export interface TerminalTask{
  increaseOrDecrease?:IncDecEnum;
  location?: LocationEnum;
  numVal?: number
  pickupOrDropoff?: PickDropEnum;
  note?:string;
  noteType?:PickDropEnum;
  taskName:string;
  dueDate?:string;
  time?: string;
  type: TerminalRunTypeEnum;
  updatedBy: string
}

export enum LocationEnum{
  ASC="ASC",
  FTC="FTC",
  Edgewood="Edgewood",
  Terminal="Terminal"
}

export enum IncDecEnum{
  increase="increase",
  decrease="decrease"
}

export enum PickDropEnum{
  pickup="pickup",
  dropoff="dropoff"
}

export enum TerminalRunTypeEnum{
  terminalRunConfirmWork="terminalRunConfirmWork",
  terminalRunRevertConfirmWork="terminalRunRevertConfirmWork",
  terminalCounter="terminalCounter",
  terminalupdate ="terminalupdate",
  terminalUpdateCoordNote="terminalUpdateCoordNote",
  terminalUpdateDriverNote="terminalUpdateDriverNote"
}
